import { ChangeDetectionStrategy, Component } from '@angular/core';

import { BaseFieldDefinition } from '../../../../../core/field-definitions/entities/field-definition.entity';
import { ExtendedBaseProfileField } from '../../../../../core/profiles/entities/extended-profile-field.entity';
import { PartialRecord } from '../../../../../core/records/entities/partial-record.class';
import { SimpleFieldValue } from '../../../../entities/field-values/field-type-values.entity';
import { FieldReadHelper } from '../../../../helpers/fields/field-read.helper';
import { ShSearchRoutingService } from '../../../../services/search-routing.service';
import { ShSimpleReadonlyFieldComponent } from '../simple-readonly-field/simple-readonly-field.component';

@Component({
    standalone: false,
    selector: 'sh-edtf-readonly-field',
    templateUrl: 'edtf-readonly-field.component.html',
    styleUrls: ['../../base-generic-readonly-field/base-generic-readonly-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShEDTFReadonlyFieldComponent extends ShSimpleReadonlyFieldComponent {
    constructor(
        protected fieldHelper: FieldReadHelper,
        protected searchRoutingService: ShSearchRoutingService
    ) {
        super(fieldHelper, searchRoutingService);
    }

    init(profileField: ExtendedBaseProfileField, record: PartialRecord): void {
        const value: SimpleFieldValue = this.fieldHelper.getEDTFFieldValue(profileField.FieldDefinition, record);
        this.value$.next(value);
    }

    canSearchEDTFOnClick(fieldDefinition: BaseFieldDefinition, value: string): boolean {
        // SOLR does not like searching on negative years
        const isNotNegative: boolean = value.indexOf('-') !== 0;
        return super.canSearchOnClick(fieldDefinition) && isNotNegative;
    }
}
